export default "__VITE_ASSET__DE1_ODpk__"